import { toPersianDigits } from '@saay/formatting';

/** Days and seconds as Persian counts with their unit. */
export function formatDays(days: number): string {
  return `${toPersianDigits(days)} روز`;
}

export function formatSeconds(seconds: number): string {
  return `${toPersianDigits(seconds)} ثانیه`;
}
